import { withMotionMax } from '@hoc/withMotionMax';
import { withQueryParams } from '@hoc/withQueryParams';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import MediaGallery from '@stories/Components/MediaGallery/MediaGallery';
import * as React from 'react';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';
import ColourPicker from './ColourPicker/ColourPicker';
import IconList from './IconList/IconList';
import S from './RangeDetailGallery.styles';
const RangeDetailGallery = ({ anchorId, allowFiltering, buttons, colourOptions, iconListOptions, galleryMedia, rangeName, pinUrl, }) => {
    const [params, setParams] = useQueryParams({
        filter: withDefault(StringParam, undefined),
    });
    const filterValues = galleryMedia.map((media) => media.filterValue);
    const [activeFilter, setActiveFilter] = React.useState(filterValues.includes(params.filter) ? params.filter : undefined);
    const [resetCarousel, setResetCarousel] = React.useState(false);
    const filteredMedia = !activeFilter?.length
        ? galleryMedia
        : galleryMedia.filter((media) => media.filterValue === activeFilter);
    const handleColourClick = (value) => {
        // reset the thumbnail carousel to the top when colour changes
        setResetCarousel(!resetCarousel);
        if (activeFilter === value) {
            handleColourReset();
            setParams({ filter: undefined });
        }
        else {
            setActiveFilter(value);
            setParams({ filter: value });
        }
    };
    const handleColourReset = () => {
        setActiveFilter('');
        setParams({ filter: undefined });
    };
    return (React.createElement(S.Container, { id: anchorId },
        React.createElement(S.Inner, { "data-mobile-stretch": true },
            React.createElement(MediaGallery, { galleryMedia: filteredMedia, pinTitle: rangeName, pinUrl: pinUrl, resetCarousel: resetCarousel })),
        (colourOptions && colourOptions.colours.length > 0) ||
            (iconListOptions && iconListOptions.length > 0) ||
            (buttons && buttons.length > 0) ? (React.createElement(S.Beneath, null,
            React.createElement(S.Inner, { "data-no-colours": !colourOptions || !colourOptions.colours || colourOptions.colours.length === 0, "data-no-options": !Array.isArray(iconListOptions) || !iconListOptions.length },
                colourOptions && colourOptions.colours.length > 0 && (React.createElement(ColourPicker, { ...colourOptions, activeFilter: params.filter ?? '', allowFiltering: allowFiltering, filterValues: filterValues, onClick: handleColourClick, onReset: handleColourReset })),
                React.createElement(S.BottomWrapper, null,
                    React.createElement(S.ListWrapper, null, iconListOptions &&
                        iconListOptions.map((il, i) => (React.createElement(IconList, { key: `icon-list-${i}`, ...il, activeFilter: params.filter ?? '', allowFiltering: allowFiltering, onClick: handleColourClick, onReset: handleColourReset })))),
                    React.createElement(S.LinkWrapper, null, buttons.map((cta, i) => (React.createElement(React.Fragment, { key: `range-button-fragment-${i}` }, cta.style && cta.style === 'link' ? (React.createElement(CtaLink, { href: cta.url, target: cta.target }, cta.text)) : (React.createElement(LinkButton, { buttonType: "default", href: cta.url, target: cta.target }, cta.text)))))))))) : null));
};
export default withQueryParams(withMotionMax(RangeDetailGallery));
